import { createFileRoute } from '@tanstack/react-router';
import { WelcomeFlow } from '../components/onboarding/welcome-flow.js';
import { WorkspaceAccessGate } from '../components/onboarding/workspace-access-gate.js';

export const Route = createFileRoute('/$workspaceSlug/welcome')({
  component: WorkspaceWelcomeRoute,
});

function WorkspaceWelcomeRoute() {
  const { workspaceSlug } = Route.useParams();
  return (
    <WorkspaceAccessGate workspaceSlug={workspaceSlug} standalone>
      <WelcomeFlow workspaceSlug={workspaceSlug} />
    </WorkspaceAccessGate>
  );
}
